import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { env } from "../../../../env";
import axiosInstance from "../../../globalInspector/axiosInstance";
import CommonToast from "../../../../components/_utils/CommonToast";
import ICONS from "../../../../assets/Icons";

const baseUrl = env.REACT_APP_BASE_URL;

const getErrorMessage = (error) =>
  error?.response?.data?.errors?.base?.[0] || error?.response?.data?.message;

export const taxCompliantAccountApprove = createAsyncThunk(
  "taxCompliantAccount/approve",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/tds/${id}/approve`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response.data;
    } catch (error) {
      const message = getErrorMessage(error);
      CommonToast({
        text: message,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      return rejectWithValue(message);
    }
  },
);

export const taxCompliantAccountReject = createAsyncThunk(
  "taxCompliantAccount/reject",
  async ({ id, rejectionReason }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/tds/${id}/reject`,
        { rejection_reason: rejectionReason },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response.data;
    } catch (error) {
      const message = getErrorMessage(error);
      CommonToast({
        text: message,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      return rejectWithValue(message);
    }
  },
);

const taxCompliantApproveRejectAccountSlice = createSlice({
  name: "taxCompliantApproveRejectAccount",
  initialState: {
    approveData: null,
    approveLoading: false,
    approveError: null,

    rejectData: null,
    rejectLoading: false,
    rejectError: null,
  },
  reducers: {
    resetApproveTaxCompliantAccount(state) {
      state.approveData = null;
      state.approveError = null;
      state.rejectData = null;
      state.rejectError = null;
      state.approveLoading = false;
      state.rejectLoading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(taxCompliantAccountApprove.pending, (state) => {
        state.approveLoading = true;
        state.approveError = null;
      })
      .addCase(taxCompliantAccountApprove.fulfilled, (state, action) => {
        state.approveLoading = false;
        state.approveData = action.payload;
      })
      .addCase(taxCompliantAccountApprove.rejected, (state, action) => {
        state.approveLoading = false;
        state.approveError = action.payload;
      })
      .addCase(taxCompliantAccountReject.pending, (state) => {
        state.rejectLoading = true;
        state.rejectError = null;
      })
      .addCase(taxCompliantAccountReject.fulfilled, (state, action) => {
        state.rejectLoading = false;
        state.rejectData = action.payload;
      })
      .addCase(taxCompliantAccountReject.rejected, (state, action) => {
        state.rejectLoading = false;
        state.rejectError = action.payload;
      });
  },
});

export const { resetApproveTaxCompliantAccount } =
  taxCompliantApproveRejectAccountSlice.actions;

export default taxCompliantApproveRejectAccountSlice.reducer;
